import "../../styles/components/contact-form.scss";

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import Parser from "html-react-parser";

import { __ } from "@wordpress/i18n";


export default class ContactFormOverlay extends Component {

	constructor(props) {
		super(props);
		this.state = {
			expanded: false,
			openWidgetVisible: true,
			closeWidgetVisible: false
		};
	}


	
	static initialize(container) {
		let contents = Parser(container.innerHTML);
		ReactDOM.render(
			<ContactFormOverlay>
				{contents}
			</ContactFormOverlay>,
			container
		);
		container.classList.remove("loading");
	}

	static initializeAll() {
		window.addEventListener("load", function() {
			const container = document.getElementById("contact-form");
			ContactFormOverlay.initialize(container);
		});
	}


	
	handleFormClick = (e) => {
		e.preventDefault();
		this.toggleForm();
	}


	openForm = () => {
		this.setState({
			expanded: true,
			openWidgetVisible: false,
			closeWidgetVisible: true,
		});
		document.body.classList.add('show-form-overlay');
	}

	closeForm = () => {
		this.setState({
			expanded: false,
			openWidgetVisible: true,
			closeWidgetVisible: false,
		});
		document.body.classList.remove('show-form-overlay');
	}

	componentDidMount() {
		let buttons = document.querySelectorAll('.contact-button');
		if ( buttons ) buttons.forEach((button) => {
			button.addEventListener('click', this.openForm);
		});
	}

	render() {
		const { expanded, closeWidgetVisible } = this.state;

		return (
			<>
			<div className={"form-container" + (expanded ? ' expand' : '') }>
				<div className="form-content">
					{this.props.children}
				</div>
				<FaTimes
					className={"form-close" + (closeWidgetVisible ? '' : ' none')}
					onClick={this.closeForm}
					size={'1.5rem'}
				/>
			</div>
			</>
		);
	}
}